/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_PaymentInputs */

const en_landing_chips_payment = /** @type {(inputs: Landing_Chips_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const zh_landing_chips_payment = /** @type {(inputs: Landing_Chips_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付系统`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Landing_Chips_PaymentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_payment = /** @type {((inputs?: Landing_Chips_PaymentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_PaymentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_payment(inputs)
	return zh_landing_chips_payment(inputs)
});
export { landing_chips_payment as "landing.chips.payment" }